module.exports = __webpack_public_path__ + "img/margin_sorted.fa39339a.png";